var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"E777B67B-EF3D-47B8-8546-23013D048AB5"),React.createElement("desc",{"key":1},"Created with sketchtool."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Main","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"landing_mobile-1-hamburger","transform":"translate(-325.000000, -25.000000)","fill":"#444444"},React.createElement("g",{"id":"Group-4","transform":"translate(325.000000, 25.000000)"},[React.createElement("rect",{"id":"Rectangle-17","x":"0","y":"0","width":"25","height":"3","key":0}),React.createElement("rect",{"id":"Rectangle-17-Copy","x":"0","y":"10","width":"25","height":"3","key":1}),React.createElement("rect",{"id":"Rectangle-17-Copy-2","x":"0","y":"20","width":"25","height":"3","key":2})])))]);
}

Menu.defaultProps = {"width":"25px","height":"23px","viewBox":"0 0 25 23","version":"1.1"};

module.exports = Menu;

Menu.default = Menu;



// WEBPACK FOOTER //
// ./src/images/icons/menu.svg